package io.horion.auth.presentation.ui.pages.verification

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleExclamation
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.api.models.domain.LoginMethod
import io.horion.auth.di.koinGet
import io.horion.auth.domain.models.AppLanguage
import io.horion.auth.presentation.ui.components.auth.AuthButton
import io.horion.auth.presentation.ui.components.layouts.PageLayoutData
import io.horion.auth.presentation.ui.pages.navigation.Screen
import io.horion.auth.presentation.ui.styles.AuthContentStyle
import io.horion.auth.presentation.ui.styles.AuthTitleStyle
import io.horion.auth.presentation.ui.styles.PageWrapperStyle
import io.horion.auth.presentation.ui.theme.AuthSpacing
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import io.horion.auth.presentation.viewmodel.AuthViewModel
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input

@InitRoute
fun initVerifyPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(AppLanguage.strings.pageTitleVerify))
}

@OptIn(DelicateApi::class)
@Page("/verify")
@Layout("io.horion.auth.presentation.ui.components.layouts.PageLayout")
@Composable
fun verifyPage() {
    val ctx = rememberPageContext()
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)
    val authViewModel = koinGet<AuthViewModel>()
    val authUiState = authViewModel.uiState
    val strings = AppLanguage.strings
    var methode by remember { mutableStateOf("") }


    LaunchedEffect(authUiState.method) {

        methode = when (authUiState.method) {
            LoginMethod.EMAIL if authUiState.phone.isNotBlank() -> {
                strings.byPhone
            }
            LoginMethod.PHONE if authUiState.email.isNotBlank() -> {
                strings.byEmail
            }
            else -> ""
        }
    }

    LaunchedEffect(authUiState.confirmSucceed) {
        if (authUiState.confirmSucceed) {
            //authViewModel.verify()
            ctx.router.navigateTo(Screen.Login.route)
        }
    }

    Box(
        modifier = PageWrapperStyle.toModifier(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = AuthContentStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Box(modifier = Modifier.height(AuthSpacing.xl))
            SpanText(
                strings.verifyTitle,
                modifier = AuthTitleStyle.toModifier()
                    .fontWeight(FontWeight.Bold)
                    .color(colors.onBackground)
            )
            Box(modifier = Modifier.height(4.px))
            SpanText(
                "${strings.verifySubtitle}${if (authUiState.method == LoginMethod.EMAIL) strings.byEmail else strings.byPhone }",
                modifier = Modifier
                    .fontSize(AuthTypography.small)
                    .color(colors.mutedText)
            )
            Box(modifier = Modifier.height(AuthSpacing.xl))

            if (authUiState.authErrorMessage != null) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(12.px)
                        .borderRadius(8.px)
                        .border(1.px, LineStyle.Solid, colors.error)
                        .styleModifier { property("background-color", "rgba(239,68,68,0.08)") }
                        .gap(8.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FaCircleExclamation(modifier = Modifier.color(colors.error).fontSize(14.px))
                    SpanText(authUiState.authErrorMessage!!, modifier = Modifier.fontSize(AuthTypography.small).color(colors.error))
                }
                Box(modifier = Modifier.height(AuthSpacing.md))
            }

            // Champ OTP + bouton "Envoyer le code"
            OtpInlineField(
                value = authUiState.code,
                onValueChange = { authViewModel.onChangeCode(it) },
                error = authUiState.codeError,
                cooldownSeconds = authUiState.otpCooldownSeconds,
                otpEnabled = true,
                onSendOtp = { authViewModel.verify() },
                colorMode = colorMode
            )
            Box(modifier = Modifier.height(AuthSpacing.sm))
            if (methode.isNotBlank()) {
                SpanText(
                    "${strings.bannerVerifyButton} $methode",
                    modifier = Modifier
                        .fontSize(AuthTypography.small)
                        .color(colors.primary)
                        .fontWeight(FontWeight.SemiBold)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            when (authUiState.method) {
                                LoginMethod.EMAIL -> authViewModel.onMethodChange(LoginMethod.PHONE)
                                LoginMethod.PHONE -> authViewModel.onMethodChange(LoginMethod.EMAIL)
                                
                            }
                            authViewModel.verify()
                        }
                )
            }
            Box(modifier = Modifier.height(AuthSpacing.xl))
            // ── Bouton connexion ─────────────────────────────────────────────
            AuthButton(
                text = strings.nextButton,
                onClick = { authViewModel.confirm() },
                loading = authUiState.isLoading,
                disabled = authUiState.code.length != 6
            )

            Box(modifier = Modifier.height(AuthSpacing.lg))
        }

    }

}

@Composable
private fun OtpInlineField(
    value: String,
onValueChange: (String) -> Unit,
    error: String?,
    cooldownSeconds: Int,
    otpEnabled: Boolean,
    onSendOtp: () -> Unit,
    colorMode: ColorMode
) {
    val colors = AuthTheme.colors(colorMode)
    val isInCooldown = cooldownSeconds > 0
    val strings = AppLanguage.strings

    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .borderRadius(12.px)
                .border(
                    2.px,
                    LineStyle.Solid,
                    if (error != null) colors.error else colors.border
                )
                .backgroundColor(colors.inputBg),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Input(type = InputType.Text, attrs = {
                value(value)
                onInput {
                    if (otpEnabled) {
                        onValueChange(it.value.filter(Char::isDigit).take(6))
                    }
                }
                attr("placeholder", if (otpEnabled) strings.otpPlaceholder else strings.otpWaitPlaceholder)
                attr("maxlength", "6")
                attr("inputmode", "numeric")
                if (!otpEnabled) attr("disabled", "true")

                style {
                    property("background", "transparent")
                    property("border", "none")
                    property("outline", "none")
                    property("color", colors.onBackground.toString())
                    property("flex", "1")
                    property("font-size", "14px")
                    property("padding", "0 14px")
                    property("height", "48px")
                    property("width", "100%")
                }
            })

            Box(
                modifier = Modifier
                    .width(1.px)
                    .height(32.px)
                    .backgroundColor(colors.borderLight)
            )

            Box(
                modifier = Modifier
                    .padding(leftRight = 14.px, topBottom = 12.px)
                    .cursor(if (!isInCooldown) Cursor.Pointer else Cursor.NotAllowed)
                    .styleModifier { property("flex-shrink", "0") }
                    .onClick {
                        if (!isInCooldown) onSendOtp()
                    },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    when {
                        isInCooldown -> "${strings.resendCode} (${cooldownSeconds}s)"
                        otpEnabled -> strings.resendCode
                        else -> strings.sendCode
                    },
                    modifier = Modifier
                        .fontSize(AuthTypography.tiny)
                        .fontWeight(FontWeight.SemiBold)
                        .color(if (!isInCooldown) colors.primary else colors.mutedText)
                        .styleModifier { property("white-space", "nowrap") }
                )
            }
        }

        error?.let {
            SpanText(
                it,
                modifier = Modifier
                    .color(colors.error)
                    .fontSize(AuthTypography.tiny)
                    .padding(top = 6.px, left = 12.px)
            )
        }
    }
}
